export function ombudsmanUrl(sector) {
  switch (sector) {
    case "energy":
      return "https://www.energyombudsman.org";
    case "communications":
    case "comms":
      return "https://www.commsombudsman.org";
    default:
      return "https://www.trustalliancegroup.org";
  }
}

export const energyPhonePretty = "0330 440 1624";
export const energyPhone = energyPhonePretty.replace(/\s/g, "");

export const commsPhonePretty = "0330 440 1614";
export const commsPhone = commsPhonePretty.replace(/\s/g, "");

export const minDateForComplaint = "2006-01-01"
